import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";

const EmpresaContext = createContext();

export function EmpresaProvider({ children }) {
  const [empresaAtiva, setEmpresaAtiva] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const montou = useRef(false);

  useEffect(() => {
    try {
      const empresaSalvaRaw = localStorage.getItem("empresaAtiva");
      const empresasSalvasRaw = localStorage.getItem("empresas");

      const empresaSalva = empresaSalvaRaw ? JSON.parse(empresaSalvaRaw) : null;
      const empresasSalvas = empresasSalvasRaw
        ? JSON.parse(empresasSalvasRaw)
        : [];

      if (Array.isArray(empresasSalvas) && empresasSalvas.length > 0) {
        setEmpresas(empresasSalvas);
      }

      if (empresaSalva?.id) {
        setEmpresaAtiva(empresaSalva);
      } else if (Array.isArray(empresasSalvas) && empresasSalvas.length > 0) {
        setEmpresaAtiva(empresasSalvas[0]);
      }
    } catch (error) {
      console.error("❌ [CTX] Erro ao restaurar localStorage:", error);
    } finally {
      montou.current = true;
    }
  }, []);

  useEffect(() => {
    if (!montou.current) return;

    try {
      if (empresaAtiva?.id) {
        localStorage.setItem("empresaAtiva", JSON.stringify(empresaAtiva));
      } else {
        localStorage.removeItem("empresaAtiva");
      }
    } catch (error) {
      console.error("❌ [CTX] Erro ao salvar empresaAtiva:", error);
    }
  }, [empresaAtiva]);

  useEffect(() => {
    if (!montou.current) return;

    try {
      if (Array.isArray(empresas) && empresas.length > 0) {
        localStorage.setItem("empresas", JSON.stringify(empresas));
      } else {
        localStorage.removeItem("empresas");
      }
    } catch (error) {
      console.error("❌ [CTX] Erro ao salvar empresas:", error);
    }
  }, [empresas]);

  const trocarEmpresa = useCallback((empresa) => {
    if (!empresa?.id) {
      setEmpresaAtiva(null);
      return;
    }

    setEmpresaAtiva((prev) => {
      if (prev?.id === empresa.id) return prev;
      return empresa;
    });
  }, []);

  const salvarEmpresas = useCallback((listaEmpresas) => {
    const lista = Array.isArray(listaEmpresas) ? listaEmpresas : [];

    setEmpresas((prev) => {
      if (JSON.stringify(prev) === JSON.stringify(lista)) return prev;
      return lista;
    });

    setEmpresaAtiva((prev) => {
      if (prev?.id && lista.some((e) => String(e.id) === String(prev.id))) {
        return prev;
      }
      return lista[0] || null;
    });
  }, []);

  return (
    <EmpresaContext.Provider
      value={{
        empresaAtiva,
        empresas,
        trocarEmpresa,
        salvarEmpresas,
      }}
    >
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresa() {
  const ctx = useContext(EmpresaContext);

  if (!ctx) {
    return {
      empresaAtiva: null,
      empresas: [],
      trocarEmpresa: () => {},
      salvarEmpresas: () => {},
    };
  }

  return ctx;
}
